<button mat-stroked-button
        class="icon-button"
        [color]="color()"
        (click)="handleClick()">
  <mat-icon>{{icon()}}</mat-icon>
</button>
